import { render, staticRenderFns } from "./RisingProduct.vue?vue&type=template&id=4cbd8cd3&scoped=true"
import script from "./RisingProduct.vue?vue&type=script&lang=js"
export * from "./RisingProduct.vue?vue&type=script&lang=js"
import style0 from "./RisingProduct.vue?vue&type=style&index=0&id=4cbd8cd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd8cd3",
  null
  
)

export default component.exports